<template>
  <div class="sme-dashboard-image">
    <div v-show="upload.status=='ready'">
      <sme-tabs>
        <sme-tab-item title="上传图片" active="true">
          <input type="file" ref="file" @change="process" accept="image/png,image/jpeg,image/gif,image/jpg" style="display: none;">
          <sme-button type="button" @click="pick">选择图片...</sme-button>
        </sme-tab-item>
        <sme-tab-item title="网络图片">
          <sme-input type="text" v-model="imageUrl" placeholder="请输入图片链接，如：http://....jpg"></sme-input>
          <sme-button type="button" @click="insertImageUrl">确定</sme-button>
        </sme-tab-item>
      </sme-tabs>
    </div>

    <div v-if="upload.status=='progress'">
      {{ $parent.locale.progress }}:{{ upload.progressComputable ? $parent.locale.unknown : upload.complete }}
    </div>

    <div v-if="upload.status=='success'">
      {{$parent.locale["please wait"]}}...
    </div>

    <div v-if="upload.status=='error'">
      {{$parent.locale.error}}:{{upload.errorMsg}}
      <sme-button type="button" @click="reset">重置</sme-button>
    </div>

    <div v-if="upload.status=='abort'">
      {{$parent.locale.upload}}&nbsp;{{$parent.locale.abort}},
      <sme-button type="button" @click="reset">重置</sme-button>
    </div>
  </div>
</template>

<script>
// import lrz from 'lrz'
import Command from '@/components/SmeEditor/range/command'
import { SmeTabs, SmeTabItem } from '@/components/SmeEditor/components/SmeTabs'
import SmeInput from '@/components/SmeEditor/components/SmeInput'
import SmeButton from '@/components/SmeEditor/components/SmeButton'

export default {
  name: 'sme-dashboard-image',
  components: {
    SmeTabs,
    SmeTabItem,
    SmeInput,
    SmeButton
  },

  data () {
    return {
      imageUrl: '',
      upload: {
        status: 'ready', // progress, success, error, abort
        errorMsg: null,
        progressComputable: false,
        complete: 0
      }
    }
  },

  methods: {
    reset () {
      this.upload.status = 'ready'
    },

    insertImageUrl () {
      if (!this.imageUrl) return
      this.$parent.execCommand(Command.INSERT_IMAGE, this.imageUrl)
      this.imageUrl = null
    },

    pick () {
      this.$refs.file.click()
    },

    setUploadError (msg) {
      this.upload.status = 'error'
      this.upload.errorMsg = msg
    },

    process () {
      const component = this
      const config = this.$options.module.config

      if (config.upload && !config.upload.url) {
        config.upload = null
      }

      const file = this.$refs.file.files[0]
      if (file.size > config.sizeLimit) {
        this.setUploadError(this.$parent.locale['exceed size limit'])
        return
      }

      this.$refs.file.value = null

      // 压缩图片
      // if (config.compress) {
      //   config.compress.fieldName = (config.upload && config.upload.fieldName)
      //     ? config.upload.fieldName
      //     : 'file'

      //   lrz(file, config.compress).then((rst) => {
      //     if (config.upload) {
      //       component.uploadToServer(rst.file)
      //     } else {
      //       component.insertBase64(rst.base64)
      //     }
      //   }).catch((err) => {
      //     this.setUploadError(err.toString())
      //   })

      //   return
      // }

      // 不需要压缩
      // base64
      if (!config.upload) {
        const reader = new FileReader()

        reader.onload = (e) => {
          component.insertBase64(e.target.result)
        }
        reader.readAsDataURL(file)
        return
      }

      // 上传服务器
      component.uploadToServer(file)
    },

    insertBase64 (data) {
      this.$parent.execCommand(Command.INSERT_IMAGE, data)
    },

    uploadToServer (file) {
      const config = this.$options.module.config
      const formData = new FormData()

      formData.append(config.upload.fieldName || 'file', file)

      if (typeof config.upload.params === 'object') {
        Object.keys(config.upload.params).forEach((key) => {
          const value = config.upload.params[key]
          if (Array.isArray(value)) {
            value.forEach((v) => {
              formData.append(key, v)
            })
          } else {
            formData.append(key, value)
          }
        })
      }

      const xhr = new XMLHttpRequest()

      xhr.onprogress = (e) => {
        this.upload.status = 'progress'

        if (e.lengthComputable) {
          this.upload.progressComputable = true
          const percentComplete = e.loaded / e.total
          this.upload.complete = (percentComplete * 100).toFixed(2)
        } else {
          this.upload.progressComputable = false
        }
      }

      xhr.onload = () => {
        if (xhr.status >= 300) {
          this.setUploadError(`request error,code ${xhr.status}`)
          return
        }

        try {
          const url = config.uploadHandler(xhr.responseText)
          if (url) {
            this.$parent.execCommand(Command.INSERT_IMAGE, url)
          }
        } catch (err) {
          this.setUploadError(err.toString())
        } finally {
          this.upload.status = 'ready'
        }
      }

      xhr.onerror = () => {
        // find network info in brower tools
        this.setUploadError('request error')
      }

      xhr.onabort = () => {
        this.upload.status = 'abort'
      }

      xhr.open('POST', config.upload.url)
      if (typeof config.upload.headers === 'object') {
        Object.keys(config.upload.headers).forEach((k) => {
          xhr.setRequestHeader(k, config.upload.headers[k])
        })
      }
      xhr.send(formData)
    }
  }
}
</script>
